// // export const API ="http://localhost:3000"
// export const ROOT_URL="http://3.110.167.23:8080/"


// export const API_PATH = ROOT_URL + '/api/v1';

// export const SUCCESSFULLY_DELETED = "Deleted successfully"
// export const ERROR = "Error";



//export const API = "http://3.110.167.23:8080";
export const API = "http://13.203.103.105:8080";
export const ROOT_URL = API;
export const API_PATH = ROOT_URL + '/api/v1';
export const SUCCESSFULLY_DELETED = "Deleted successfully";
export const ERROR = "Error";